import { render } from "./Disabled.vue?vue&type=template&id=16884519"
import script from "./Disabled.vue?vue&type=script&lang=js"
export * from "./Disabled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__